<div class="gear1"></div>
<div class="gear2"></div>

<div class="centered">
<div class="bck" style="text-align: -webkit-center">
  <mat-card class="speech-bubble " xmlns="http://www.w3.org/1999/html" >
    <div style="text-align: -webkit-center">
      <div class="maherlogo"></div>

    </div>
    <div class="titleFonts">We'll Be Back Soon!</div>
    <div style="font-family: 'Open Sans' ; font-weight: bold; font-size: 25px; padding-top: 10px; text-align: -webkit-center">
      Please be advised that we are performing system maintenance until approximately midnight EST tonight.
      Please accept our sincere apologies for any inconvenience that this may cause.
    </div>
  </mat-card>
</div>
</div>
